import {Toast} from "primereact/toast";
import React, {useEffect, useRef, useState} from "react";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {AutoComplete} from "primereact/autocomplete";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {useForm} from "react-hook-form";
import {getAsociados} from "../../../api/liquidacionDeduccion.service";
import {getClients} from "../../../api/factura.service";
import {UseLoader} from "../../../hooks/useLoader";
import {confirmDialog} from "primereact/confirmdialog";
import {guardarData} from "../../../api/asociadoContrato.service";


export const ModalNuevoAsociadoContrato = ({show, hide}) => {

    const [handleLoader] = UseLoader();
    const [selectedcliente, setSelectedcliente] = useState({
        nombre: "",
        id: "",
        tipo: ""
    });
    const [selectedAsociado, setSelectedAsociado] = useState({
        nombre: "",
        id: ""
    });
    const toast = useRef(null);
    const [FilteredCliente, setFilteredCliente] = useState(null);
    const [FilteredAsociado, setFilteredAsociado] = useState(null);
    const [clientes, setClientes] = useState([]);
    const [asociados, setAsociados] = useState([]);
    const {register, handleSubmit, formState: {errors}} = useForm();

    const initParams = {
        cliente_id: '',
    };
    const [field, setField] = useState(initParams);

    useEffect(() => {
        getAsociados().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setAsociados(r.data)
        }).catch(r => console.log(r))
        return () => {
            if (asociados.length > 0) {
                setAsociados([]);
            }
        };
    }, []);

    useEffect(() => {
        getClients().then(r => {
            if (r.estado !== 200) {
                return;
            }
            setClientes(r.data)
        }).catch(r => console.log(r))
        return () => {
            if (clientes.length > 0) {
                setClientes([]);
            }
        };
    }, []);

    const searchCliente = (event) => {
        setTimeout(() => {
            let _filteredCliente;
            if (!event.query.trim().length) {
                _filteredCliente = [...clientes];
            } else {
                _filteredCliente = clientes.filter((cliente) => {
                    return cliente.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCliente(_filteredCliente);
        }, 250);
    }

    const searchAsociado = (event) => {
        setTimeout(() => {
            let _filteredAsociado;
            if (!event.query.trim().length) {
                _filteredAsociado = [...asociados];
            } else {
                _filteredAsociado = asociados.filter((asociado) => {
                    return asociado.nombre.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredAsociado(_filteredAsociado);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex ">
                <div className="ml-3">{item.nombre}</div>
            </div>
        );
    }

    const onSubmit= async payload => {
        try {
            const datos= {
                cliente_id: selectedcliente.id,
                asociado_id: selectedAsociado.id
            }
            if (datos.asociado_id !== '' && datos.cliente_id !== ''){
                confirmDialog({
                    message: '¿Estas seguro?',
                    header: 'Confirmación',
                    acceptLabel: "Si",
                    rejectLabel: "No",
                    accept: async () =>  {
                        handleLoader(true);
                        const response= await guardarData(datos);
                        const data= await response.data;

                        handleLoader(false);
                        if (data.estado !== 200) {
                            toast.current?.show({severity:'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                            return;
                        }

                        toast.current?.show({severity:'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                        hide();
                    }
                });
            }

        } catch (e) {
            handleLoader(false)
            console.log(e)
        }
    }

    return(
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Anexar nuevo asociado al cliente" visible={show} style={{width: '70vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={handleSubmit(onSubmit)} autoComplete="false">
                            <h6 className="title-modal">
                                Información Asociados
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="cliente"
                                    >
                                        Cliente *
                                    </label>
                                    <AutoComplete value={selectedcliente} suggestions={FilteredCliente}
                                                  style={{"width": "100%"}}
                                                  completeMethod={searchCliente}
                                                  placeholder="Buscador clientes"
                                                  size="30"
                                                  field="nombre" dropdown itemTemplate={itemTemplate}
                                                  onChange={(e) => setSelectedcliente(e.value)}/>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="asociado"
                                    >
                                        Asociado *
                                    </label>
                                    <AutoComplete value={selectedAsociado} suggestions={FilteredAsociado}
                                                  style={{"width": "100%"}}
                                                  completeMethod={searchAsociado}
                                                  placeholder="Buscador de asociados"
                                                  size="30"
                                                  field="nombre" dropdown itemTemplate={itemTemplate}
                                                  onChange={(e) => setSelectedAsociado(e.value)}/>
                                </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Agregar
                                    </button>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>
                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>
        </>
    )
}
